import type { SelectHTMLAttributes } from "react";
import {
  FieldErrorMessage,
  RequiredMark,
  fieldLabelClassName,
  fieldFocusCn,
} from "./fieldHelpers";
import { ChevronDown } from "packages/dsaui/src/components/icons";
import { cn } from "packages/dsaui/src/utils";

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  errorMessage?: string | null;
  placeholder?: string;
  disabledMessage?: string;
}

export const Select = ({
  id,
  label,
  required,
  errorMessage,
  placeholder,
  className,
  children,
  ...props
}: SelectProps) => (
  <div className="flex w-full flex-col gap-1 text-left">
    {label ? (
      <label htmlFor={id ?? props.name} className={fieldLabelClassName}>
        {label}
        <RequiredMark required={required} />
      </label>
    ) : null}
    <div className="relative">
      <select
        id={id ?? props.name}
        className={cn(
          "w-full appearance-none rounded-[6px] border border-gray-300 bg-white px-[13px] py-[9px] pr-10 text-base leading-6 font-normal text-gray-900 shadow-sm disabled:cursor-not-allowed disabled:bg-gray-50",
          fieldFocusCn(errorMessage),
          className,
        )}
        {...props}
      >
        {placeholder ? (
          <option value="" disabled>
            {placeholder}
          </option>
        ) : null}
        {children}
      </select>
      <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-500">
        <ChevronDown className="size-5" />
      </span>
    </div>
    {errorMessage ? (
      <FieldErrorMessage id={`${id ?? props.name}-message`}>
        {errorMessage}
      </FieldErrorMessage>
    ) : null}
  </div>
);

export default Select;
